export const CART_METAFIELDS = {
    SALES_CHANNEL: {
        key: 'sales-channel',
        namespace: 'cart',
    },
    PAYMENT_PLAN_DETAILS: {
        key: 'payment-plan-details',
        namespace: 'payment',
    },
    SESSION_ID: {
        key: 'session-id',
        namespace: 'cart',
    },
}
